import { render, staticRenderFns } from "./BrowserSupport.vue?vue&type=template&id=3e8ffcea"
import script from "./BrowserSupport.vue?vue&type=script&lang=js"
export * from "./BrowserSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports